import React, { createContext, Dispatch  } from 'react';
import  { Enum } from "./../resources/constants"

// Interfaces
import { Travel, Origin, Destination, Location } from "../interfaces/travel"

const { Form, TravelMod, TravelType } = Enum;

interface ProvinceType {
    id: string,
    name: string,
    cities: CityType[],
}
interface CityType {
    id: string,
    name: string,
    locations: Location[],
    destinations?: CityType[],
    origins?: CityType[],
}
interface OwnerType {
    id: string,
    company: string,
}
interface CarType {
    id: string,
    name: string,
}
export default createContext<{
    openDrawer: boolean,
    openTour: boolean,
    origin: Origin|null,
    originLocation: Location|null,
    destination: Destination|null,
    destinationLocation: Location|null,
    directions: any,
    startDirectionsIcon: {setPosition: any, setMap: any, setIcon: any},
    endDirectionsIcon: {setPosition: any, setMap: any, setIcon: any},
    form: string,
    user: {
        id: string;
        firstName: string|null;
        lastName: string|null;
        nationalCode: string|null;
        mobile: string;
        roles: [];
        permissions: [];
        complete: boolean;
    }|null,
    provinces: ProvinceType[],
    owners: OwnerType[],
    cars: CarType[],
    filter: {},
    travel: Travel|{},
    travelMod: string,
    travelType: string,
    isOpenFloatButton: boolean,
    dispatch: Dispatch<{ type: string, payload: object }>
}>({
    openDrawer: false,
    openTour: false,
    origin: null,
    originLocation: null,
    destination: null,
    destinationLocation: null,
    directions: null,
    startDirectionsIcon: {
        setPosition: () => {},
        setMap: () => {},
        setIcon: () => {}
    },
    endDirectionsIcon: {
        setPosition: () => {},
        setMap: () => {},
        setIcon: () => {}
    },
    user: null,
    provinces: [],
    owners: [],
    cars: [],
    filter: {},
    travel: {},
    travelMod: TravelMod.NEW,
    travelType: TravelType.Person,
    form: Form.FILTER,
    isOpenFloatButton: false,
    dispatch: () => {}
})
